<template>
  <vs-row vs-justify="center" id="organization-box">
    <vs-col type="flex" vs-lg="12" vs-xs="12">
      <vs-card id="form">
        <vs-tabs :value="activeTab" style="height: 80vh;">
          <vs-tab
            :label="$t('Organization.OrganizationShow.Tabs.BasicInformation')"
            icon="info"
            id="information-tab"
          >
            <vs-row class="mt-4">
              <vs-col type="flex" vs-lg="12" vs-xs="12">
                <vs-row class="mt-4">
                  <vs-col vs-lg="8" vs-xs="12" vs-sm="12" class="w-10">
                    <vs-row>
                      <vs-col vs-w="6">
                        <vs-input
                          :label="$t('Reseller.Table.Responsible')"
                          v-model="reseller.responsible"
                          class="w-100 mb-2"
                        />
                      </vs-col>
                      <vs-col vs-w="6">
                        <vs-input
                          :label="$t('Reseller.Table.Email')"
                          v-model="reseller.email"
                          class="w-100 mb-2"
                        />
                      </vs-col>
                    </vs-row>
                    <vs-row>
                      <vs-col vs-w="6">
                        <vs-input
                          :label="$t('Reseller.Table.Phone')"
                          v-model="reseller.phone"
                          class="w-100 mb-2 mt-2"
                        />
                      </vs-col>
                      <vs-col vs-w="6">
                        <vs-input
                          :label="$t('Reseller.Table.SocialReason')"
                          v-model="reseller.social_reason"
                          class="w-100 mt-2"
                        />
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <br />
                <div class="btn-alignment float-right mt-4">
                  <vs-button color="primary" @click="updateReseller">{{
                    $t("Organization.UpdateButton")
                  }}</vs-button>
                </div>
              </vs-col>
            </vs-row>
          </vs-tab>
          <vs-tab
            :label="$t('Reseller.GrantAccess')"
            icon="check"
            id="team-tab"
            style="height: 100vh;"
          >
            <div class="mb-4">
              <h4 class="mb-2">{{ $t('Menu.Organizations') }}:</h4>
              <multiselect
                v-model="valueOrg"
                :options="optionsOrg"
                :custom-label="customLabel"
                track-by="id"
                :loading="isLoadingOrg"
                :internal-search="false"
                :close-on-select="true"
                :options-limit="300"
                :max-height="500"
                :show-no-results="false"
                :hide-selected="true"
                :multiple="true"
                open-direction="bottom"
                @search-change="delayedSearchOrg"
                selectLabel=""
                :preserveSearch="true"
              >
              </multiselect>
            </div>
            <div class="mb-3">
              <h4 class="mb-2">{{ $t('Menu.Business') }}:</h4>
              <multiselect
                v-model="valueBus"
                :options="optionsBus"
                :custom-label="customLabel2"
                track-by="id"
                :loading="isLoadingBus"
                :internal-search="false"
                :close-on-select="true"
                :options-limit="300"
                :max-height="500"
                :show-no-results="false"
                :hide-selected="true"
                :multiple="true"
                open-direction="bottom"
                @search-change="delayedSearchBus"
                selectLabel=""
                :preserveSearch="true"
              >
              </multiselect>
            </div>

            <div class="mb-3">
              <h4 class="mb-2">{{ $t('Menu.Industries') }}:</h4>
              <multiselect
                v-model="valueIndustry"
                :options="optionsIndustry"
                :custom-label="customLabel2"
                track-by="id"
                :loading="isLoadingIndustry"
                :internal-search="false"
                :close-on-select="true"
                :options-limit="300"
                :max-height="500"
                :show-no-results="false"
                :hide-selected="true"
                :multiple="true"
                open-direction="bottom"
                @search-change="delayedSearchIndustry"
                selectLabel=""
                :preserveSearch="true"
              >
              </multiselect>
            </div>

            <div class="mb-3">
              <h4 class="mb-2">{{ $t('Menu.Services') }}:</h4>
              <multiselect
                v-model="valueService"
                :options="optionsService"
                :custom-label="customLabel2"
                track-by="id"
                :loading="isLoadingServices"
                :internal-search="false"
                :close-on-select="true"
                :options-limit="300"
                :max-height="500"
                :show-no-results="false"
                :hide-selected="true"
                :multiple="true"
                open-direction="bottom"
                @search-change="delayedSearchService"
                selectLabel=""
                :preserveSearch="true"
              >
              </multiselect>
            </div>

            <div class="btn-alignment float-right mt-5">
              <vs-button color="primary" @click="checkFields">{{
                $t("Organization.UpdateButton")
              }}</vs-button>
            </div>
          </vs-tab>
        </vs-tabs>
      </vs-card>
    </vs-col>
    <div class="centerx con-exemple-prompt">
      <vs-prompt
        @accept="updateResellerAccess()"
        color="danger"
        @cancel="activeEmptyField = false"
        @close="activeEmptyField = false"
        :active.sync="activeEmptyField"
      >
        <div class="con-exemple-prompt">
          L'envoie d'un champs vide signifie que vous écraser toute informtaions
          déja saisie.
        </div>
      </vs-prompt>
    </div>
  </vs-row>
</template>

<script>
import {
  organizationService,
  businessService,
  resellerService,
  serviceServices,
  industryServices
} from "../../_services";
import { gmapApi } from "vue2-google-maps";
import router from "../../_helpers/router";
import index from "../../components/Team/index";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

export default {
  name: "Organization",
  data: () => ({
    title: "Organization",
    activeEmptyField: false,
    optionsOrg: [],
    optionsBus: [],
    optionsIndustry: [],
    optionsService: [],
    valueOrg: [],
    valueBus: [],
    valueIndustry: [],
    valueService: [],
    isLoadingOrg: false,
    isLoadingBus: false,
    isLoadingIndustry: false,
    isLoadingServices: false,
    searching: false,
    activeTab: 0,
    reseller: {},
    organization: {
      labels: {
        agencies: {
          change: false,
          fr: null,
          en: null,
          ar: null,
        },
        clients: {
          change: false,
          fr: null,
          en: null,
          ar: null,
        },
      },
    },
    logo: "",
    cover_photo: "",
    teamTotalPages: 0,
    teamCurrentPage: 1,
    currentLocation: { lat: 0, lng: 0 },
    markers: [],
    teamMembers: null,
    industries: [],
    timer: null,
  }),
  computed: {
    google: gmapApi,
  },
  methods: {
    checkFields() {
      if (this.valueOrg.length == 0 || this.valueBus.length == 0 || this.valueIndustry.length == 0 || this.valueService.length == 0) {
        this.activeEmptyField = true;
      } else {
        this.updateResellerAccess();
      }
    },
    updateResellerAccess() {
      var requestCycle = 0;
      this.showLoading();

      var payloadBus = new FormData();
      payloadBus.append("model", "Business");
      payloadBus.append("access", "");
      payloadBus.append("_method", "POST");

      var payloadOrg = new FormData();
      payloadOrg.append("model", "Organization");
      payloadOrg.append("access", "");
      payloadOrg.append("_method", "POST");

      var payloadIndustry = new FormData();
      payloadIndustry.append("model", "Industry");
      payloadIndustry.append("access", "");
      payloadIndustry.append("_method", "POST");

      var payloadService = new FormData();
      payloadService.append("model", "Service");
      payloadService.append("access", "");
      payloadService.append("_method", "POST");

      if (this.valueBus.length != 0) {
        payloadBus.set("access", this.valueBus.map((el) => el.id).join());
      }
      if (this.valueOrg.length != 0) {
        payloadOrg.set("access", this.valueOrg.map((el) => el.id).join());
      }
      if (this.valueIndustry.length != 0) {
        payloadIndustry.set("access", this.valueIndustry.map((el) => el.id).join());
      }
      if (this.valueService.length != 0) {
        payloadService.set("access", this.valueService.map((el) => el.id).join());
      }

      while(requestCycle != 4) {
        console.log(requestCycle)
        resellerService
        .grantAccess(requestCycle == 0 ? payloadBus : requestCycle == 1 ? payloadOrg : requestCycle == 2 ? payloadIndustry : payloadService, this.$route.params.id)
        .then(
          function() {
            this.notify(
                    this.$t("Toasts.Successful"),
                    this.$t("Reseller.Toast.AccessSucces"),
                    "success"
                  );
          }.bind(this)
        )
        .catch(
          function() {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Reseller.Toast.UpdateFailed"),
              "danger"
            );
          }.bind(this)
        )
        .finally(
          function() {
            this.hideLoading();
          }.bind(this)
        );
        requestCycle += 1;
      }
    },
    customLabel({ name }) {
      return `${name}`;
    },
    customLabel2({ name }) {
      return `${name}`;
    },
    delayedSearchOrg(query) {
      clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.asyncFindOrg(query);
      }, 300);
    },
    delayedSearchBus(query) {
      clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.asyncFindBus(query);
      }, 300);
    },
    delayedSearchIndustry(query) {
      clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.asyncFindIndustry(query);
      }, 300);
    },
    delayedSearchService(query) {
      clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.asyncFindServices(query);
      }, 300);
    },
    // filter organizations
    asyncFindOrg(query) {
      if (query.length > 0) {
        this.isLoadingOrg = true;
        resellerService
          .filterOrganizations(encodeURIComponent(query))
          .then(
            function(data) {
              this.optionsOrg = [];
              data.organizations.forEach((obj) => {
                this.optionsOrg.push({
                  id: obj.id,
                  name: obj.name,
                });
              });
            }.bind(this)
          )
          .catch(
            function() {
              this.optionsOrg = [];
            }.bind(this)
          )
          .finally(
            function() {
              this.isLoadingOrg = false;
            }.bind(this)
          );
      }
    },
    // filter businesses
    asyncFindBus(query) {
      if (query.length > 0) {
        this.isLoadingBus = true;
        resellerService
          .filterBusinesses(encodeURIComponent(query))
          .then(
            function(data) {
              this.optionsBus = [];
              data.businesses.forEach((obj) => {
                this.optionsBus.push({
                  id: obj.id,
                  name: obj.name,
                });
              });
            }.bind(this)
          )
          .catch(
            function() {
              this.optionsBus = [];
            }.bind(this)
          )
          .finally(
            function() {
              this.isLoadingBus = false;
            }.bind(this)
          );
      }
    },
    // filter industries
    asyncFindIndustry(query) {
      if (query.length > 0) {
        let payload = {
          name: query
        }
        this.isLoadingIndustry = true;

          industryServices.filter(payload).then(function (data) {
            this.optionsIndustry = [];
            data.industries.data.forEach((obj) => {
                this.optionsIndustry.push({
                  id: obj.id,
                  name: obj.name,
                });
              });
          }.bind(this))
          .finally(() => {
            this.isLoadingIndustry = false;
          });
      }
    },
    // filter services
    asyncFindServices(query) {
      if (query.length > 0) {
        this.isLoadingServices = true;

          serviceServices
        .search(query, 1)
        .then(
          function(data) {
            this.optionsService = [];
            data.services.data.forEach((obj) => {
                this.optionsService.push({
                  id: obj.id,
                  name: obj.title,
                });
              });
          }.bind(this)
        )
        .finally(
          function() {
            this.isLoadingServices = false;
          }.bind(this)
        );
      }
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#organization-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#organization-box > .con-vs-loading");
    },
    updateCoordinates(location) {
      this.markers[0].position = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
      console.log(this.markers[0].position);
    },
    goToNextTab(currentStep) {
      this.$tours["SettingsBusiness"].nextStep();
      if (currentStep == 1) {
        this.activeTab = 1;
      } else if (currentStep == 2) {
        this.activeTab = 2;
      }
    },
    goToNextPage() {
      router.push({ path: "/settings/team?istour=on" });
    },
    updateReseller() {
      this.showLoading();
      let reseller = new FormData();
      reseller.append("responsible", this.reseller.responsible);
      reseller.append("email", this.reseller.email);
      reseller.append("phone", this.reseller.phone);
      reseller.append("social_reason", this.reseller.social_reason);
      reseller.append("_method", "POST");

      resellerService
        .update(reseller, this.reseller.id)
        .then(
          function(data) {
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Company.EditBasic.ToastSuccess"),
              "success"
            );
          }.bind(this)
        )
        .catch(
          function() {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Company.EditBasic.ToastFail"),
              "danger"
            );
          }.bind(this)
        )
        .finally(
          function() {
            resellerService
              .getById(this.$route.params.id)
              .then((data) => {
                this.reseller = data.data;
              })
              .finally(() => {
                this.hideLoading();
              });
          }.bind(this)
        );
      // console.log(this.business.working_days);
    },
  },
  mounted() {
    this.showLoading();
    resellerService
      .getById(this.$route.params.id)
      .then((data) => {
        this.reseller = data.data;
        // get reseller accesses if exist
        this.reseller.accesses.forEach((el) => {
          if (el.model == "Organization") {
            if(el.access != 0) {
            const myArray = el.access.split(",");
            myArray.forEach((el) =>
              organizationService.getById(el).then((data) => {
                this.valueOrg.push({id: data.organization.id, name: data.organization.name})
              }).catch()
            );
            }
          } else if(el.model == "Industry") {
            if(el.access != 0) {
            industryServices.getAll().then((data) => {
              const myArray = el.access.split(",");
              myArray.forEach((el) =>
                this.valueIndustry.push(data.industries.find((o) => o.id == el))
              );
              }).catch()
            }
          } else if(el.model == "Service") {
            if(el.access != 0) {
            const myArray = el.access.split(",");
            myArray.forEach((el) =>
              serviceServices.getById(el).then((data) => {
                this.valueService.push({id: data.service.id, name: data.service.title})
              }).catch()
            );
            }
          } else {
            if(el.access != 0) {
            const myArray = el.access.split(",");
            myArray.forEach((el) =>
              businessService.getById(el).then((data) => {
                this.valueBus.push({id: data.business.id, name: data.business.name})
              }).catch()
            );
            }
          }
        });
      })
      .finally(() => {
        this.hideLoading();
      });
  },
  components: {
    index,
    Multiselect,
  },
};
</script>

<style>
.input-labels {
  width: 100%;
}
</style>
